module.exports = __webpack_public_path__ + "fonts/Canela-Medium.af81dc5.woff2";